module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGPC/xhBQAAAThJREFUeAHt2zEOQjEMRMEP978zcAB3a60p5peREkvzFNGQ5/ERIEDgTOD1+X1n0w1+3gxuBQS49XcDjv0FEOBa4Hi+3wABjgWOx7sBAhwLHI93AwQ4FjCeAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBBYEvJRfQEyO8EAj0VvYK8ACYnKEAInewl4BFhCTIwRI9Bb2CrCAmBwhQKK3sFeABcTkCAESvYW9AiwgJkcIkOjZS4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgUHAG7EBpbnkn3FN7WGWAANKc0mApvYwS4ABpbkkQFN7mCXAgNJcEqCpPcwSYEBpLgnQ1B5mCTCgNJcEaGqbRYAAgf8S+AKTMww6pxpyoAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white/hamburger.png
// module id = 14
// module chunks = 0